import React from 'react';
import { Link } from 'react-router-dom';
import logoMark from '../../assets/navbar-logo-mark-dark.svg';
import logoWordmark from '../../assets/navbar-logo-wordmark-dark.svg';
import locationIcon from '../../assets/icons/location.svg';
import phoneIcon from '../../assets/icons/phone.svg';
import emailIcon from '../../assets/icons/email.svg';
import facebookIcon from '../../assets/icons/facebook.svg';
import twitterIcon from '../../assets/icons/twitter.svg';
import linkedinIcon from '../../assets/icons/linkedin.svg';
import youtubeIcon from '../../assets/icons/youtube.svg';
import './footer-new.css';

const Footer = () => (
  <footer className="kw__footer">
    <div className="kw__footer_inner">
      <div className="kw__footer_columns">
        {/* Contact Us */}
        <div>
          <h4 className="kw__footer_col-heading">Contact Us</h4>
          <div className="kw__footer_contact-item">
            <img src={locationIcon} alt="" className="kw__footer_contact-icon" />
            <span className="kw__footer_contact-text">Houston, Texas</span>
          </div>
          <div className="kw__footer_contact-item">
            <img src={phoneIcon} alt="" className="kw__footer_contact-icon" />
            <span className="kw__footer_contact-text">
              <a href="tel:+13465474580">+1 (346) 547-4580</a>
            </span>
          </div>
          <div className="kw__footer_contact-item">
            <img src={emailIcon} alt="" className="kw__footer_contact-icon" />
            <span className="kw__footer_contact-text">
              <a href="mailto:admin@kothawalagroup.com">admin@kothawalagroup.com</a>
            </span>
          </div>
        </div>

        {/* Company */}
        <div>
          <h4 className="kw__footer_col-heading">Company</h4>
          <div className="kw__footer_link-list">
            <Link to="/portfolio" className="kw__footer_link">Our Portfolio</Link>
            <Link to="/sell-your-business" className="kw__footer_link">Sell Your Business</Link>
            <Link to="/investors" className="kw__footer_link">Investors</Link>
          </div>
        </div>

        {/* Discover */}
        <div>
          <h4 className="kw__footer_col-heading">Discover</h4>
          <div className="kw__footer_link-list">
            <Link to="/careers" className="kw__footer_link">Join the Team</Link>
            <Link to="/whats-new" className="kw__footer_link">What&apos;s New?</Link>
          </div>
        </div>

        {/* Information */}
        <div>
          <h4 className="kw__footer_col-heading">Information</h4>
          <div className="kw__footer_link-list">
            <Link to="/privacy#privacy-policy" className="kw__footer_link">Privacy Policy</Link>
            <Link to="/privacy#sms-terms" className="kw__footer_link">SMS Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>

      <hr className="kw__footer_divider" />

      <div className="kw__footer_bottom">
        <Link to="/" className="kw__footer_bottom-logo">
          <img src={logoMark} alt="" aria-hidden="true" className="kw__footer_bottom-logo-mark" />
          <img src={logoWordmark} alt="Kothawala Group" className="kw__footer_bottom-logo-wordmark" />
        </Link>
        <p className="kw__footer_copyright">© 2026 Kothawala Group All rights reserved</p>
        <div className="kw__footer_socials">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" className="kw__footer_social-icon" />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <img src={twitterIcon} alt="Twitter" className="kw__footer_social-icon" />
          </a>
          <a href="https://www.linkedin.com/company/kothawala-group/" target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="LinkedIn" className="kw__footer_social-icon" />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <img src={youtubeIcon} alt="YouTube" className="kw__footer_social-icon" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
